module.exports = __webpack_public_path__ + "img/weddings_32_V.f73b2fd7.webp";